// components/Layout/Sidebar.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdHome, MdPrecisionManufacturing, MdBuild } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSelector } from 'react-redux';
import SidebarModule from './SidebarModule';
import { canAccessModule } from '../../../utils/auth/permissions';
import './Sidebar.css';

const sidebarModules = [
    {
        key: "product",
        title: "Product Mgmt.",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/products", label: "Products", icon: MdPrecisionManufacturing },
            { to: "/category", label: "Category", icon: MdBuild },
            { to: "/filter", label: "Filter", icon: MdBuild },
            { to: "/color", label: "Color", icon: MdBuild },
            { to: "/collection-partner", label: "Partner", icon: MdBuild },
        ],
    },
    {
        key: "rawMaterial",
        title: "Raw Material",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/raw-material-categories", label: "RM Categories", icon: MdBuild },
            { to: "/raw-material-vendors", label: "RM Vendors", icon: MdBuild },
            { to: "/raw-material", label: "Raw Material", icon: MdBuild },
            { to: "/inventory", label: "Inventory", icon: MdBuild },
        ],
    },
    {
        key: "portfolio",
        title: "Portfolio",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/portfolio", label: "Portfolio Projects", icon: MdBuild },
        ],
    },
    {
        key: "office",
        title: "Office",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/offices", label: "Office Listing", icon: MdBuild },
        ],
    },
    {
        key: "blog",
        title: "Blog",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/blogs", label: "Blogs", icon: MdBuild },
            { to: "/blog-categories", label: "Categories", icon: MdBuild },
        ],
    },
    {
        key: "lead",
        title: "Leads",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/leads", label: "Leads", icon: MdBuild },
        ],
    },
    {
        key: "project",
        title: "Project",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/projects", label: "Projects", icon: MdBuild },
        ],
    },
    {
        key: "measureInstall",
        title: "Measure & Install",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/measurement-requests", label: "Requests", icon: MdBuild },
        ],
    },
    {
        key: "users",
        title: "Users",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/portal-users", label: "Portal Users", icon: MdBuild },
        ],
    }
];

const Sidebar = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { pathname } = useLocation();
    const { user } = useSelector(state => state.auth); // adjust if your slice stores user elsewhere

    const isActive = (link) => {
        if (link.match === "startsWith") return pathname.startsWith(link.to);
        return pathname === link.to;
    };

    // Filter modules by permission
    const visibleModules = sidebarModules.filter(m => canAccessModule(user, m.key));

    return (
        <div className={`sidebar bg-light ${isCollapsed ? "collapsed" : ""}`}>
            <div className="sidebar-header">
                <button
                    className="toggle-btn"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    <GiHamburgerMenu />
                </button>
                {!isCollapsed && <h1 className="sidebar-title">Dashboard</h1>}
            </div>

            <nav>
                <Link to="/" className={pathname === "/" ? "active" : ""}>
                    <MdHome />
                    {!isCollapsed && <span>Homepage</span>}
                </Link>

                {visibleModules.map((module) => (
                    <SidebarModule
                        key={module.title}
                        title={module.title}
                        icon={module.icon}
                        isCollapsed={isCollapsed}
                    >
                        {module.links.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className={isActive(link) ? "active" : ""}
                            >
                                <link.icon />
                                {!isCollapsed && <span>{link.label}</span>}
                            </Link>
                        ))}
                    </SidebarModule>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;